import moment from 'moment-timezone'

import api from 'common/api'

import types from './types'

const fetchClassYears = () => {
  return (dispatch, getState) => {
    const state = getState()
    const highSchoolId = state.user.record.HighSchool.Id
    const classYearsState = state.classYears
    const lastTime = classYearsState.fetchedTime
    if (!classYearsState.isFetching && moment().isAfter(moment.unix(lastTime).add(5, 'minute'))) {
      dispatch({ type: types.FETCH_CLASS_YEARS_START })
      api
        .get(`/api/high_school/${highSchoolId}/class_years`)
        .then((years) => {
          dispatch({
            type: types.FETCH_CLASS_YEARS_SUCCESS,
            payload: {
              years,
              fetchedTime: moment().unix(),
            },
          })
        })
        .catch(() => {
          dispatch({ type: types.FETCH_CLASS_YEARS_FAILURE })
        })
    }
  }
}

export default {
  fetchClassYears,
}
